import { useClaims } from '@lmt/unicorn-shared/app/features/auth/operations';

export function useIsSuperUser() {
  const claims = useClaims();
  return claims.permissions.superuser;
}
